import React from 'react';
import { Link } from 'react-router-dom';
import { ImageCardProps } from '../../interface';
import './index.css';

interface ImageCardPropsExtended extends ImageCardProps {
  spanTwoColumns: boolean;
}

export const ImageCard = ({
  image,
  spanTwoColumns,
}: ImageCardPropsExtended) => {
  return (
    <div className={`image-container ${spanTwoColumns ? 'span-two' : ''}`}>
      <img src={image.src} alt={image.title} className="image" />
      <div className="overlay">
        <p>{image.description}</p>
        <Link to={`/services/${image.id}`} state={{ image: image }}>
          <button>Read more</button>
        </Link>
      </div>
    </div>
  );
};
